import { ReactNode } from 'react';

import { ILanguages, languages } from '@picsart/rc/languages';
import { ReactINTLProvider } from '@picsart/rc/services/localization';
import useLocalization from 'hooks/useLocalization';

type INTLProviderProps = {
  isLocalized: boolean;
  slug: string;
  children: ReactNode;
  languagesList: ILanguages;
  translatedData?: Record<string, string>;
};

const INTLProvider = ({
  children,
  languagesList = languages,
  isLocalized = false,
  slug = '',
  translatedData,
}: INTLProviderProps) => {
  const { language } = useLocalization(Object.keys(languagesList || {}) as any);

  return (
    <ReactINTLProvider
      projectName={`landings,web_growth&slug=${slug}`}
      mergeDefaultTranslatedData={!translatedData}
      language={language}
      showLangBar={isLocalized}
      languagesList={languagesList}
      defaultTranslatedData={translatedData}
    >
      {children}
    </ReactINTLProvider>
  );
};
export default INTLProvider;
